import {useEffect, useState} from "react";
import {Button, Col, ConfigProvider, Form, Input, Row, Select} from "antd";
import {SFuncModal} from "shj-components";
import {sendPhoneCodeNonAuth, uCenterSendPhoneCode, uCenterVerifyPhoneCode} from "@/services";
import styles from '../index.module.less'

interface IProps {
  data: any;
  checkInfo: any
  onClose: () => void
  onChangeCheckState: (state: boolean) => void
  onOpenForm: () => void
}

const CheckIDForm = (props: IProps) => {
  const {data, onClose, onChangeCheckState, onOpenForm} = props;
  let [form] = Form.useForm();

  const [isGetting, setIsGetting] = useState<boolean>(false)
  const [sendCodeLoading, setSendCodeLoading] = useState<boolean>(false)
  const [waitingTime, setWaitingTime] = useState<number>(60)

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(props.data);
  }, [props.data]);


  useEffect(() => {
    let timer;
    if (isGetting) {
      timer = setTimeout(() => {
        if (waitingTime > 0) {
          setWaitingTime(waitingTime - 1)
        } else {
          setIsGetting(false)
        }
        timer && clearTimeout(timer)
      }, 1000)
    } else {
      timer && clearTimeout(timer)
      setWaitingTime(60)
    }
  }, [isGetting, waitingTime])


  const prefixSelector = (
      <Form.Item name="prefix" noStyle>
        <Select defaultValue={'86'} style={{width: 100}}>
          <Select.Option value="86">+86</Select.Option>
        </Select>
      </Form.Item>
  );

  const onGetCheckCode = () => {
    form.validateFields(['phone']).then(()=>{
      setSendCodeLoading(true);
      // uCenterSendPhoneCode({phone: data.phone})
      uCenterSendPhoneCode({phone: data.phone})
          .then(() => {
            setIsGetting(true);
            setSendCodeLoading(false);
          })
          .catch(() => {
            setIsGetting(false);
            setSendCodeLoading(false);
          })
    })
  }

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form
          .validateFields()
          .then((values) => {
            uCenterVerifyPhoneCode(values).then(() => {
              localStorage.setItem('checkInfo', JSON.stringify({...props?.checkInfo, [data.userId]: +new Date}))
              resolve();
              // message.success('验证成功')
              onOpenForm()
              onChangeCheckState(true)
              onClose()
            })

          })
          .catch(reject);
    });
  };

  return (
      <SFuncModal.Content
          okText={'确定'}
          onOk={onFinish}
          onCancel={onClose}
          confirmLoading={false}
      >
        <Form form={form} layout={'vertical'}>
          <Form.Item>为了你的账户安全，请通过身份验证，验证成功后才可进行下一步操作</Form.Item>
          <Form.Item label={'当前手机号'} name={'phone'}
                     rules={[{required: true, message: '手机号不能为空'}, {
                       pattern: /^1[\d]{10}/,
                       message: '请输入正确格式的手机号'
                     }]}
          >
            <Input disabled placeholder={'请输入当前手机号'} maxLength={11} minLength={11} addonBefore={prefixSelector}
                   style={{width: '100%'}}/>
          </Form.Item>
          <Row>
            <Col span={18}>
              <Form.Item
                  name="code"
                  label={'验证码'}
                  className={styles.mb_0}
                  rules={[{required: true, message: '验证码不能为空'}]}
              >
                <Input style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}} placeholder="请输入验证码"/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        defaultBg: '#fafafa',
                        defaultActiveBg: '#fafafa',
                        defaultHoverBg: '#fafafa',
                        defaultActiveBorderColor: '#d9d9d9',
                        defaultHoverBorderColor: '#d9d9d9',
                        defaultActiveColor: '#000000e0',
                        defaultHoverColor: '#000000e0',
                      },
                    },
                  }}
              >
                <Button
                    className={styles.right_code_btn}
                    block
                    onClick={onGetCheckCode}
                    disabled={isGetting}
                    loading={sendCodeLoading}
                >
                  {!isGetting ? '获取验证码' : `${waitingTime} s`}
                </Button>
              </ConfigProvider>
            </Col>
          </Row>

        </Form>
      </SFuncModal.Content>);
};

export default CheckIDForm